'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var ScrollView = _interopDefault(require('../scroll-view'));
var clickoutside = _interopDefault(require('../directive/click-outside'));
var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('scroll-view', {
      directives: [{
        name: "clickoutside",
        rawName: "v-clickoutside:touchstart",
        value: _vm.reset,
        expression: "reset",
        arg: "touchstart"
      }],
      ref: "scrollView",
      staticClass: "swipe-out",
      attrs: {
        "mode": "slide",
        "slide": "24%",
        "slideIndex": _vm.slideIndex,
        "scrollX": true
      },
      on: {
        "update:slideIndex": function updateSlideIndex($event) {
          _vm.slideIndex = $event;
        }
      }
    }, [_c('div', {
      staticClass: "swipe-out-box"
    }, [_c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "swipe-out-content",
      on: {
        "click": _vm.clickContent
      }
    }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
      directives: [{
        name: "tap",
        rawName: "v-tap"
      }],
      staticClass: "swipe-out-button",
      on: {
        "click": _vm.clickButton
      }
    }, [_vm._v(_vm._s(_vm.text))])])]);
  },
  staticRenderFns: [],
  name: 'swipe-out',
  components: {
    ScrollView: ScrollView
  },
  directives: {
    clickoutside: clickoutside
  },
  props: {
    text: {
      type: String,
      default: '删除'
    }
  },
  data: function data() {
    return {
      slideIndex: 0
    };
  },
  methods: {
    clickContent: function clickContent() {
      if (this.slideIndex) {
        this.reset();
      } else {
        this.$emit('clickContent');
      }
    },
    clickButton: function clickButton() {
      this.$emit('clickButton');
    },
    reset: function reset() {
      var scrollView = this.$refs.scrollView;
      this.slideIndex = 0;
      scrollView.$emit('scrollX', 0, 300);
    }
  }
});

exports.default = index;
